import { Bar, mixins } from 'vue-chartjs';

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  name: 'ChartStudentCount',
  props: {
    chartData: Object,
    options: Object,
    styles: Object,
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
